
import softLi from '~/components/company/softwareComponent/softLi.vue'
export default {
  components: {
    'soft-li': softLi
  },
  // inject: ['main'],
  props: {
    softval: {
      type: Object,
      default: () => {}
    },
     titleVal: {
        type: String,
        default: ''
      }
  },
  data() {
    return {
      show: false,
      imgArr: [],
      imgIndex: 0,
      ece2: -1,
      detail: {},
      listCount: 5,
      bigimgShow: false
    }
  },
  watch:{
    show(v){
      if (v) {
        document.body.style.setProperty('overflow', 'hidden', 'important')
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    wapShow() {
      return this.$store.state.mobile
    }
  },
  mounted() {
    if (document && document.documentElement && document.documentElement.clientWidth <= 999) {
      this.listCount = 4
    } else {
      this.listCount = 5
    }
    window.addEventListener('resize', () => {
      if (document && document.documentElement && document.documentElement.clientWidth <= 999) {
        this.listCount = 4
      } else {
        this.listCount = 5
      }
    })
    const that = this
    document.addEventListener('keydown', function (e) {
      if (e.keyCode == 27) {
        that.bigimgShow = false
      }
    })
    console.log(this.wapShow, 'wapShow1111');
  },
  methods: {
    pre() {
      if (this.imgIndex <= 0) return
      this.imgIndex--
      const c = this.imgIndex - (this.imgArr.length - this.listCount)
      if (c <= 0) {
        this.setimg(this.imgArr[this.imgIndex])
        const left = `-${Number(c * 73)}px`
        const mt = document.getElementById('mt-t-list-p')
        if (mt) {
          mt.style.transform = `translateX(${left})`
        }
      }
    },
    next() {
      if (this.imgIndex >= this.imgArr.length - 1) {
        // this.imgIndex = 0
        return
      }
      this.imgIndex++
      const c = this.imgIndex - this.listCount
      console.log(this.imgIndex, this.imgArr.length, 333)
      if (c >= 0) {
        this.setimg(this.imgArr[this.imgIndex])
        const left = `-${Number((c + 1) * 73)}px`

        const mt = document.getElementById('mt-t-list-p')
        if (mt) {
          mt.style.transform = `translateX(${left})`
        }
      }
    },
    open() {
      // 打开弹框
      this.imgArr = []
      this.imgIndex = 0
      this.ece2 = -1
      this.getDetail()
    },
    close() {
      // 关闭弹框
      document.body.style.overflow = 'auto'
      this.show = false
    },
    fuzhi(val) {
      // 复制文本
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', val)
      input.select()
      document.execCommand('Copy')
      this.$message({
        message: this.$v('复制成功'),
        type: 'success'
      })
      document.body.removeChild(input)
    },
    tabmt45(index) {
      // 切换ecn2
      // this.ece2 = index
      if (this.ece2 == index) {
        this.ece2 = -1
      } else {
        this.ece2 = index
      }
    },
    getDetail() {
      // 获取相关软件详情页
      this.$api.dealer
        .softwaredetail({
          traderCode: this.softval.traderCode,
          softwareInfoCode: this.softval.softwareInfoId,
          associationId: this.softval.associationId
        })
        .then((res) => {
          for (const key in res) {
            this.$set(this.detail, key, res[key])
          }
          this.imgArr = [...res.images]
          document.body.style.overflow = 'hidden'
          this.show = true
          this.$nextTick(() => {
            const mt = document.getElementById('mt-t-list-p')
            if (mt) {
              mt.style.transform = 'translateX(0)'
            }

            this.setimg(res.images[0])
          })
        })
    },
    setimg(img) {
      const softImg = document.getElementById('softImg')
      const ig = new Image()
      ig.src = img
      ig.onload = () => {
        if (softImg) {
          const width = ig.width
          if (width >= 696) {
            softImg.style.width = '100%'
          } else {
            softImg.style.width = 'auto'
            softImg.style['max-width'] = '100%'
          }
        }
      }
    }
  }
}
